import { render, staticRenderFns } from "./KnowledgeBaseWidget.vue?vue&type=template&id=5239bb20&"
import script from "./KnowledgeBaseWidget.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports